require('./js/curriculumManager');
